export default class DateTimeHelper {

  convertICUHours(inputInMinutes) {
    // Convert minutes to seconds
    let seconds = inputInMinutes ? inputInMinutes * 60 : 0;

    // Calculate (and subtract) whole hours
    const hours = Math.floor(seconds / 3600);
    seconds -= hours * 3600;

    // Calculate (and subtract) whole minutes
    const minutes = Math.floor(seconds / 60) % 60;

    return hours + ':' + (minutes < 10 ? '0' + minutes : minutes);
  }
}



// WEBPACK FOOTER //
// ./client/app/common/utils/DateTimeHelper.js